module.exports = __webpack_public_path__ + "static/media/expense.decd7950.png";